import { CAMPUS_PREFIX } from 'campus/routes';
import { isPartnerDomain } from 'campus/boot/alias-styles';
import { appThemeOverride, setForcedLight } from 'src/composables/useAppTheme';
import { STOP_NAVIGATION } from './constants';

const CAMPUS_BODY_CLASS = 'campus-root';
const CAMPUS_CANCEL = 'campus:cancel';

/**
 * Граница кампусной зоны — первое правило в цепочке.
 *
 * Кампусные пути обрабатывает только модуль Кампуса: правило возвращает
 * результат и обрывает цепочку, поэтому ruleAdmin, ruleEnsureAuth и остальные
 * админские правила на /campus/* не выполняются (и наоборот — вне зоны это
 * правило сразу отдаёт управление дальше).
 *
 * Класс зоны вешается на <body>, а не на корень лейаута: Quasar телепортирует
 * QTooltip / QMenu / QDialog в body, и без этого попапы Кампуса остались бы вне
 * скоупа его стилей и фирменных цветов.
 *
 * Модуль Кампуса подгружается динамически, чтобы не попасть в стартовый чанк
 * админки.
 *
 * @param {object} ctx
 * @param {import('vue-router').RouteLocationNormalized} ctx.to
 * @param {import('vue-router').RouteLocationNormalized} ctx.from
 * @returns {Promise<false|true|object|symbol>} false — продолжить цепочку админки.
 */
let campusThemeApplied = false;
let campusLightForced = false;

export async function ruleCampusZone (ctx) {
    const isCampus = ctx.to.path === CAMPUS_PREFIX || ctx.to.path.startsWith(`${CAMPUS_PREFIX}/`);

    document.body.classList.toggle(CAMPUS_BODY_CLASS, isCampus);

    if (isCampus) {
        campusLightForced = true;

        // Кампус светлый, пока тему не выбрали; на партнёрском домене — всегда
        // (фирменная тема рассчитана только на светлую).
        setForcedLight(isPartnerDomain() || appThemeOverride.value === null);
    } else if (campusLightForced) {
        campusLightForced = false;

        setForcedLight(false);
    }

    if (!isCampus) {
        // Тема Кампуса задаёт --q-primary на :root и красит .bg-primary через
        // !important, поэтому на выходе из зоны её нужно снять — иначе она
        // перекрасит админку на edu-rosnou.ru и platforma-fa.ru.
        if (campusThemeApplied) {
            campusThemeApplied = false;

            const { disableCampusTheme } = await import('campus/theme');

            disableCampusTheme();
        }

        return false;
    }

    if (!campusThemeApplied) {
        campusThemeApplied = true;

        const { enableCampusTheme } = await import('campus/theme');

        enableCampusTheme();
    }

    const { default: campusGuard } = await import('campus/guard');
    const result = await campusGuard(ctx);

    return result === CAMPUS_CANCEL ? STOP_NAVIGATION : result;
}
